import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import App from "./App";
import ProtectedRoute from "./components/widgets/ProtectedRoute/ProtectedRoute";
import CurrentlyReading from "./pages/CurrentlyReading";
import HistoryReading from "./pages/HistoryReading";
import Home from "./pages/Home";

//Routes
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <Home /> },
      { path: "HistoryReading", element: <HistoryReading /> },
      {
        path: "CurrentlyReading",
        element: (
          <ProtectedRoute>
            <CurrentlyReading />
          </ProtectedRoute>
        ),
      },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);

//Render the app
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider
      router={router}
      future={{
        v7_startTransition: true,
      }}
    />
  </React.StrictMode>
);
